import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b25716a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings-default-wrap" }
const _hoisted_2 = { class: "settings-default" }
const _hoisted_3 = { class: "screen-wrap" }
const _hoisted_4 = {
  key: 1,
  class: "setting-wrap"
}
const _hoisted_5 = { class: "popup-content" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "popup-text-block" }
const _hoisted_8 = { class: "popup-title" }
const _hoisted_9 = { class: "popup-text" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Ok")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_ScreenSettings = _resolveComponent("ScreenSettings")!
  const _component_UserList = _resolveComponent("UserList")!
  const _component_ExpandedSettings = _resolveComponent("ExpandedSettings")!
  const _component_ChangeLayout = _resolveComponent("ChangeLayout")!
  const _component_ChooseDevices = _resolveComponent("ChooseDevices")!
  const _component_UsersInTheMeeting = _resolveComponent("UsersInTheMeeting")!
  const _component_MenuSettings = _resolveComponent("MenuSettings")!
  const _component_MobileExpandedSettings = _resolveComponent("MobileExpandedSettings")!
  const _component_Drawer = _resolveComponent("Drawer")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_Typography = _resolveComponent("Typography")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isMobileScreen)
        ? (_openBlock(), _createBlock(_component_Logo, {
            key: 0,
            class: "admin-logo",
            size: "medium"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ScreenSettings, {
          class: "screen-default",
          deviceError: _ctx.deviceError
        }, null, 8, ["deviceError"])
      ]),
      (!_ctx.isMobileScreen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_UserList, { onOpenUser: _ctx.showExpandedUserList }, null, 8, ["onOpenUser"]),
            (!_ctx.showAllUser)
              ? (_openBlock(), _createBlock(_component_ExpandedSettings, {
                  key: 0,
                  class: "panel-default",
                  deviceError: _ctx.deviceError
                }, null, 8, ["deviceError"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Drawer, null, {
      default: _withCtx(() => [
        (_ctx.drawerStore.section === 'changeLayout')
          ? (_openBlock(), _createBlock(_component_ChangeLayout, { key: 0 }))
          : (_ctx.drawerStore.section === 'chooseDevices')
            ? (_openBlock(), _createBlock(_component_ChooseDevices, {
                key: 1,
                "device-type": _ctx.drawerStore.options.type
              }, null, 8, ["device-type"]))
            : (_ctx.drawerStore.section === 'userInTheMeeting')
              ? (_openBlock(), _createBlock(_component_UsersInTheMeeting, { key: 2 }))
              : (_ctx.drawerStore.section === 'settings')
                ? (_openBlock(), _createBlock(_component_MenuSettings, {
                    key: 3,
                    class: "menu-drawer",
                    isMenu: true,
                    mode: "default"
                  }))
                : (_ctx.drawerStore.section === 'generalSettings')
                  ? (_openBlock(), _createBlock(_component_MobileExpandedSettings, {
                      key: 4,
                      deviceError: _ctx.deviceError
                    }, null, 8, ["deviceError"]))
                  : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.popup.opened && _ctx.popup.section === 'device-permission')
      ? (_openBlock(), _createBlock(_component_Popup, {
          key: 0,
          class: "popup-content"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "allow-devices-img",
                src: _ctx.allowDevicesImg
              }, null, 8, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.t('error.browserPermission.popUpTitle')), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.t('error.browserPermission.popUpDescription')), 1),
                _createVNode(_component_Button, {
                  size: "m",
                  mode: "secondary",
                  width: "fill-container",
                  onClick: _ctx.close
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.popup.opened && _ctx.popup.section === 'join-token-not-valid')
      ? (_openBlock(), _createBlock(_component_Popup, {
          key: 1,
          class: "popup-content"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Typography, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('tokenNotValid.onJoinTitle')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Button, { onClick: _ctx.routeToAuth }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('tokenNotValid.okButton')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.popup.opened && _ctx.popup.section === 'auth-failed')
      ? (_openBlock(), _createBlock(_component_Popup, {
          key: 2,
          class: "popup-content"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Typography, {
              fontType: "header",
              fontSize: "500",
              fontColor: "--gray900"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('authFailed.title')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Button, { onClick: _ctx.reloadPage }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('authFailed.button')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}